<template>
    <div class="form-group w-full px-1">
        <label for="body" class="form-label" v-text="label"></label>
        <editor
            :name="name"
            :value="content"
            :init="settings"
            tag-name="textarea"></editor>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
    name: 'TextEditor',
    props: [
        'content', 'label', 'name'
    ],

    components: {
        editor: Editor,
    },

    data() {
        return {
            settings: {
                menubar: false,
                menu: [],
                plugins: [
                    'lists link code fullscreen paste wordcount',
                ],
                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link',
                relative_urls: false,
                paste_as_text: true,
            }
        }
    },
}
</script>

<style lang="css">
    .tox-tinymce {
        min-height: 250px;
        width: 100%;
    }

    .tox-notification {
        display: none !important;
    }
</style>
